import {connect} from 'react-redux';
import Blog from './Blog';

const getActualState = (state) =>(
    {
        state
    }
)

const actions = (dispatch) =>(
    {
        eventsActions: (type,payload) => dispatch({type,...payload})
    }
)

export default connect(getActualState,actions)(Blog);